module.exports = __webpack_public_path__ + "img/337.cb74dcdc.jpg";